import {
  ArpTableContext,
  Filters,
  Headers,
  Root,
  SongRemixRoot,
  SPRemixRoot,
  Table
} from './components'
import { DEFAULT_SONGS_FILTERS, DEFAULT_SOUNDS_FILTERS } from './hooks'
import * as Primitives from './primitives'

export const ArpTable = {
  ArpTableContext,
  Root,
  SPRemixRoot,
  SongRemixRoot,
  Headers,
  Table,
  Filters,
  DEFAULT_SOUNDS_FILTERS,
  DEFAULT_SONGS_FILTERS,
  Primitives
}
